import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppSettings } from '../../../../utils/app-settings';
import { Observable } from 'rxjs';
import { PreviousQuestionPaper } from '../models/previous-question-paper';
import { PreviousQuestionPaperUrl } from '../models/previous-question-paper-url';

@Injectable({
  providedIn: 'root'
})
export class PreviousQuestionPaperService {

  constructor(private http: HttpClient) { }

  getAllSharedQuestionPapers(studentId: number): Observable<Array<Array<PreviousQuestionPaper>>> {
    return this.http.get<Array<Array<PreviousQuestionPaper>>>(AppSettings.apiUrl + "previousquestionpaper/" + studentId);
  }

  getQuestionPaperUrlandType(questionPaperId: number): Observable<PreviousQuestionPaperUrl> {
    return this.http.get<PreviousQuestionPaperUrl>(AppSettings.apiUrl + "previousquestionpaper/get-url/" + questionPaperId);
  }
}
